<template>
  <div class="text-center">
    <vueper-slides
      autoplay
      fixed-height="300px"
      class="no-shadow"
      :visible-slides="1"
      :arrows-outside="false"
      :bullets="false"
      :infinite="true"
      :dragging-distance="100"
      :touchable="true"
      :disable-arrows-on-edges="true"
      style="margin-bottom: 1rem"
    >
      <template #arrow-left>
        <font-awesome-icon :icon="['fas', 'chevron-left']" />
      </template>

      <template #arrow-right>
        <font-awesome-icon :icon="['fas', 'chevron-right']" />
      </template>
      <vueper-slide v-for="(slide, i) in slides" :key="i" :image="slide.image">
        <template #content>
          <div class="vueperslide__content-wrapper"></div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "Slider",
  data() {
    return {
      title: "Slider",
      slides: [
        {
          image: require("@/assets/images/slider/1.png"),
        },
        {
          image: require("@/assets/images/slider/2.png"),
        },
        {
          image: require("@/assets/images/slider/3.png"),
        },
        {
          image: require("@/assets/images/slider/4.png"),
        },
        {
          image: require("@/assets/images/slider/5.png"),
        },
        {
          image: require("@/assets/images/slider/6.png"),
        },
        {
          image: require("@/assets/images/slider/7.png"),
        },
        {
          image: require("@/assets/images/slider/8.png"),
        },
        {
          image: require("@/assets/images/slider/9.png"),
        },
      ],
    };
  },
  components: { VueperSlides, VueperSlide },
};
</script>
